export enum SigningType {
  InkSign = 'InkSign',
  ESign = 'ESign',
  ENotarize = 'ENotarize',
  InkNotarize = 'InkNotarize',
}
